<template>
  <div class="devicebelongoperate">
    <span class="top-info">
      <!-- <div class="info-one">
        <span class="label">
          <i class="status-icon-shadow" :class="deviceStatus.class"></i>
        </span>
        <span class="namebox">
          <span class="name">{{dataloggerInfo2.alias}}</span>
        </span>
      </div> -->
      <!-- 数采器PN -->
      <div class="info-one">
        <span class="label">
          <i class="status-icon-shadow" :class="deviceStatus.class"></i>
        </span>
        <div style="font-size:20px">
          <span>{{ $t('recharge.DataloggerPN') }}</span>
          <span id="loggerPN">{{ deviceInfo.pn }}</span>
        </div>
        <i @click="copy()" style="color:#33FFB6;padding-left:10px;" class="iconfont icon-biaogegongneng_fuzhi"></i>

      </div>
    </span>
    <div class="top-operate gTool">
      <div class="gRowA">
        <!-- :title="$t('datalogger.edit')" -->
        <!-- scope.row.pn -->
        <!-- @click="editDatalogger(dataloggerInfo.pn)" -->
        <!-- @click="dialogDataloggerVisible=true" -->
        <!-- dataloggerInfo2.pn -->
        <el-button type="text" class="operation" @click="editDatalogger(deviceInfo)">
          <i class="iconfont icon-bianji"></i>
          <!-- 编辑 -->
          <span class="icon-text1">{{ $t('datalogger.edit') }}</span>
        </el-button>
        <!-- :title="$t('report.Export_report')" -->
        <!-- [scope.row] -->
        <!-- 报表 -->
        <!-- <el-button
          v-show="activeTab == 'devicebelonginfo'"
          type="text"
          class="operation"
          @click="exportPlant([dataloggerInfo2])"
        >
          <i class="iconfont icon-baobiao"></i>
          
			  	<span class="icon-text1">{{$t('device.report')}}</span>
        </el-button> -->
        <!-- :title="$t('datalogger.debug')" -->
        <!-- scope.row.pn -->
        <el-button type="text" class="operation" :title="$t('datalogger.reboot')"
          @click="rebootDatalogger(deviceInfo)">
          <i class="iconfont icon-a-mingchengkaiguanji"></i>
          <!-- 重启 -->
          <span class="icon-text1">{{ $t('datalogger.reboot') }}</span>
        </el-button>
        <el-button type="text" class="operation" @click="debugDatalogger(deviceInfo)">
          <i class="iconfont icon-caozuo_tiaoshi"></i>
          <!-- 调试 -->
          <span class="icon-text1">{{ $t('datalogger.debug') }}</span>
        </el-button>
      </div>
      <div class="gRowB">
        <!-- :title="$t('datalogger.upgrade')" -->
        <!-- scope.row -->
        <el-button type="text" class="operation" @click="upgradeDatalogger(deviceInfo)">
          <i class="iconfont icon-shengji"></i>
          <!-- 升级 -->
          <span class="icon-text1">{{ $t('datalogger.upDatalogger') }}</span>
        </el-button>
        <!-- 重置 -->
        <!-- <el-button
          v-if="this.$store.state.user.role==1"
          type="text"
          class="operation delBgc"
          :title="$t('datalogger.reset')"
          @click="resetDatalogger(dataloggerInfo2.pn)"
        >
          <i class="iconfont icon-a-mingchengcaijiqishezhi"></i>
          <span class="icon-text1">{{$t('datalogger.reset')}}</span>
        </el-button> -->
        <!-- 解绑 -->
        <el-button v-if="this.$store.state.user.role == 1" :disabled="deviceInfo.usr ? false : true" type="text"
          class="operation delBgc" :title="$t('datalogger.unbind')" @click="unbindDatalogger(deviceInfo.pn)">
          <i class="iconfont icon-a-mingchengyonghushuxingshanchu2"></i>
          <span class="icon-text1">{{ $t('datalogger.unbind') }}</span>
        </el-button>
        <!-- :title="$t('datalogger.delete')" -->
        <!-- scope.row.pn -->
        <el-button v-if="this.$store.state.user.role == 2" type="text" class="operation delBgc"
          @click="deleteDatalogger(deviceInfo.pn)">
          <i class="iconfont icon-shanchu"></i>
          <!-- 删除 -->
          <span class="icon-text1">{{ $t('datalogger.delete') }}</span>
        </el-button>
      </div>
    </div>

    <!-- 导出 -->
    <export-plant-dialog :params.sync="exportPlantParams"></export-plant-dialog>

    <!-- 调试数采器 -->
    <!-- v-if="debugDataloggerVisible" -->
    <control-dialog :title="$t('datalogger.datalogger_debug')"
      :class="{ 'showDialog': debugDataloggerVisible, 'hideDialog': !debugDataloggerVisible }"
      :visible.sync="debugDataloggerVisible" noFooter>
      <div slot="content">
        <el-form class="grid">
          <el-form-item :label="$t('datalogger.communication_address')" size="small">
            <el-input type="number" v-model="datalogger.devaddr" auto-complete="off"  oninput="if(value<1)value=1;if(value>255)value=255"></el-input>
          </el-form-item>
          <el-form-item :label="$t('datalogger.Instruction')" size="small">
            <el-input v-model="devDebug.cmd" :placeholder="$t('datalogger.such_as')" type="textarea"
              auto-complete="off"></el-input>
          </el-form-item>
          <!-- 发送指令 -->
          <el-form-item label=" ">
            <div style="text-align:right;">
              <button class="btn btn-dark" type="primary" @click="submitDebugDatalogger()">{{ $t('device.send')
              }}</button>
            </div>
          </el-form-item>
          <el-form-item :label="$t('datalogger.return_content')" size="small">
            <div class="debug-return">
              <!-- id="link" -->
              <el-input readonly id="link" v-model="debugReturn" type="textarea" auto-complete="off"></el-input>
              <div class="return-tool">
                <span class="btn" style="margin-right:15px;" @click="fuzhi($event)" data-clipboard-action="copy"
                  data-clipboard-target="#link">
                  <i class="ico ico-copy"></i>
                  {{ $t('device.copy_val') }}
                </span>
                <span class="btn" @click="qingkong()">
                  <i class="ico ico-clear"></i>
                  {{ $t('device.clear_val') }}
                </span>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <!-- <button class="button-solid" 
          @click="qingkong()"
        >{{$t('datalogger.clear_data')}}</button> -->
        <!-- <button
          class="button-solid"
          type="primary"
          @click="submitDebugDatalogger()"
        >{{$t('datalogger.send')}}</button> -->
      </div>
    </control-dialog>
    <!-- 重启数采器 -->
    <control-dialog :title="$t('datalogger.rebootDataloggerName')"
      :class="{ 'showDialog': rebootDataloggerVisible, 'hideDialog': !rebootDataloggerVisible }"
      :visible.sync="rebootDataloggerVisible" noFooter>
      <div slot="content">
        <div style="color:#EC9630;font-size:18px;font-weight:700;margin-bottom:50px;">
          <span>{{ $t('datalogger.fixOnRebootDataloggerName') }}</span>
          <span>{{ this.rebootDataloggerData.pn }}</span>
          <span>{{ $t('datalogger.fixOnRebootDataloggerName1') }}</span>
        </div>
        <div style="text-align:right;">
          <button class="btn btn-light" style="margin-right:10px;" @click="rebootDataloggerCencel()">{{
            $t('device.cancel') }}</button>
          <!-- <button class="btn btn-dark" @click="rebootDataloggerConfirm()">{{ $t('device.confirm') }}</button> -->
          <button
            class="btn btn-dark"
            :disabled="rebooting"
            @click="rebootDataloggerConfirm()"
          >
            <span v-if="!rebooting">{{ $t('device.confirm') }}</span>
            <span v-else>
              <i class="el-icon-loading"></i> {{ $t('device.confirm') }}
            </span>
          </button>
        </div>
      </div>
      <div slot="footer">
      </div>
    </control-dialog>
    <!-- 固件升级 -->
    <!-- v-if="upgradeDataloggerVisible" -->
    <control-dialog :title="$t('firmware.firmware_upgrade')"
      :class="{ 'showDialog': upgradeDataloggerVisible, 'hideDialog': !upgradeDataloggerVisible }"
      :visible.sync="upgradeDataloggerVisible" width="580px" noFooter>
      <div slot="content">
        <el-form class="grid upload-container upgradeNew">
          <el-form-item :label="$t('datalogger.select_firmware')" size="small">
            <el-select v-model="searchrecharge" @change="voltageArr($event)" :placeholder="$t('datalogger.select_file')"
              popper-class="select-search-recharge select-search-project">
              <template slot="empty">
                <div style="text-align:right;">
                  <button type="button" class="upFirewareBtn" @click="dialogAdd = true;">{{ $t('firmware.Upload_firmware')
                  }}</button>
                </div>
              </template>
              <div style="text-align:right;">
                <button type="button" class="upFirewareBtn" @click="dialogAdd = true;">{{ $t('firmware.Upload_firmware')
                }}</button>
              </div>
              <el-option v-for="item in rechargelist" :key="item.value" :label="item.firmware"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label=" ">
            <div class="processstatue" v-show="progressUp">{{ $t('firmware.upgrading') }}</div>
            <div class="processstatue" v-show="progerssComplete">{{ $t('firmware.updateCompleted') }}</div>
            <!-- 原上传按钮 -->
            <!-- <div class="upload-contents">
              <button class="upload-button" @click.prevent="$refs.fileUploader.click()">
                <i class="iconfont icon-shangchuan"></i>
                {{$t('datalogger.Upload')}}
              </button>
              <div class="upload-tip">{{$t('firmware.limit')}}</div>
            </div> -->
            <div class="progressShow" v-show="progressUp">
              <div class="progressName">
                <i class="iconfont icon-fujian"></i>
                {{ firmwareName }}
              </div>
              <div class="progressCancel" @click="upgradeCancel">
                <i class="iconfont icon-delete"></i>
              </div>
            </div>
            <div class="processData" v-show="progressUp">
              <el-progress :format="progressText" :percentage="progress" :stroke-width="10" color="#33FFB6"></el-progress>
              <div class="processBig">{{ uploadNowSize }}M / {{ uploadTotalSize }}M</div>
            </div>
            <!-- 原上传按钮 -->
            <!-- <input
              type="file"
              class="upload-input"
              ref="fileUploader"
              accept="application/octet-stream"
              @change="uploadfile($event)"
            /> -->
            <div class="progerssComplete" v-show="progerssComplete">
              <div class="progressName">
                <i class="iconfont icon-fujian"></i>
                {{ firmwareName }}
              </div>
              <div class="progressCancel"></div>
            </div>
          </el-form-item>
        </el-form>
        <div style="text-align:right;">
          <button type="button" class="btn btn-dark" @click="submitUpgradeDatalogger">{{ $t('datalogger.confirm')
          }}</button>
        </div>
      </div>
      <div slot="footer">
        <!-- <button
            class="button-hollow"
            @click="upgradeDataloggerVisible = false"
        >{{$t('datalogger.cancel')}}</button>-->
        <!-- <button class="button-solid" @click="submitUpgradeDatalogger">{{$t('datalogger.confirm')}}</button> -->
      </div>
    </control-dialog>
    <!-- 固件升级二次弹窗（增加固件的对话框） -->
    <!-- style="z-index:2014!important;" -->
    <!-- v-if="dialogAdd" -->
    <!-- :class="{'showDialog': dialogAdd, 'hideDialog': !dialogAdd}" -->
    <update-dialog :title="$t('firmware.Upload_firmware')" v-if="dialogAdd" :visible.sync="dialogAdd" width="40vw"
      noFooter style="z-index:3000;">
      <div slot="content">
        <el-form class="grid upload-container">
          <!-- <p>{{$t('firmware.Firmware_description')}}</p> -->
          <el-form-item :label="$t('firmware.Firmware_description')" size="small">
            <el-input v-model="desc" :placeholder="$t('firmware.enter_content')"></el-input>
          </el-form-item>
          <el-form-item label=" ">
            <div class="upload-contents">
              <button type="button" class="upload-buttonEquipment" @click.prevent="$refs.fileUploader.click()">
                <i class="iconfont icon-shangchuan1"></i>
                <!-- {{$t('datalogger.Upload')}} -->
              </button>
              <div class="upload-tip">{{ `${$t('datalogger.Upload')} (${$t('firmware.limit0')})` }}</div>
              <input type="file" class="upload-input" ref="fileUploader" accept="application/octet-stream"
                @change="uploadfile($event)" />
            </div>
          </el-form-item>
        </el-form>
        <div style="text-align:right;">
          <button type="button" class="btn btn-dark" @click="dialogAdd = false">{{ $t('datalogger.confirm') }}</button>
          <!-- <button class="btn btn-light" @click="dialogAdd = false">{{$t('firmware.cancel')}}</button> -->
        </div>
      </div>
      <div slot="footer">
        <!-- <button class="button-solid" @click="dialogAdd = false">{{$t('datalogger.confirm')}}</button> -->
        <!-- <button class="button-hollow" @click="dialogAdd = false">{{$t('firmware.cancel')}}</button> -->
      </div>
    </update-dialog>
    <!-- 升级结果提示(成功) -->
    <!-- v-if="upgradeDataloggerSucVisible" -->
    <control-dialog :title="$t('datalogger.editResults')" :visible.sync="upgradeDataloggerSucVisible"
      :class="{ 'showDialog': upgradeDataloggerSucVisible, 'hideDialog': !upgradeDataloggerSucVisible }" width="500px"
      noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <!-- <span class="showresulttext">{{$t('datalogger.modifySuc')}}</span> -->
          <span class="showresulttext">{{ dataloggerTipMsg }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button type="button" class="btn btn-dark" @click="upgradeDataloggerSucVisible = false;">{{
              $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </control-dialog>
    <!-- 升级结果提示(失败) -->
    <!-- v-if="upgradeDataloggerFailVisible" -->
    <control-dialog :title="$t('datalogger.editResults')" :visible.sync="upgradeDataloggerFailVisible"
      :class="{ 'showDialog': upgradeDataloggerFailVisible, 'hideDialog': !upgradeDataloggerFailVisible }" width="500px"
      noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresulttext">{{ dataloggerTipMsg }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button type="button" class="btn btn-dark" @click="upgradeDataloggerFailVisible = false;">{{
              $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </control-dialog>

    <!-- 删除设备 去掉弹框的heard不加title=""和footer noFooter -->
    <!-- v-if="deletingDataloggerId" -->
    <control-dialog :title="$t('datalogger.deleteTitle')" :visible.sync="deletingDataloggerId"
      :class="{ 'showDialog': deletingDataloggerId, 'hideDialog': !deletingDataloggerId }" width="30vw" noFooter>
      <div slot="content">
        <!-- <div class="tital">
          <span class="contentdelete" style="width:100%;text-align:left;">{{$t('datalogger.confirm_deldte')}}</span>
        </div> -->
        <div style="font-size:16px;color:#DD6843;">{{ $t('datalogger.confirm_deldte') }}</div>
        <div style="color:#D9E2E6;font-size:14px;margin:10px 0 20px;">
          <span>{{ $t('recharge.DataloggerPN') }}</span>
          <span>{{ this.deletingDataloggerId }}</span>
        </div>
        <el-input style="margin-bottom:30px;" v-model="resetDataloggerCode" :placeholder="$t('datalogger.please_title')"></el-input>
        <div style="text-align:right;">
          <button class="btn btn-light" style="margin-right:10px;color:#DD6843;border:1px solid #DD6843 "
            @click="deletingDataloggerId = null">{{ $t('device.cancel') }}</button>
          <button style="background:#DD6843;" class="btn btn-dark" @click="submitDeleteDatalogger()">{{
            $t('datalogger.delete') }}</button>
        </div>
        <!-- <div class="disabledescr">
          <span style="width:100%;text-align:left;margin-top:28px;">{{$t('account.notRecovered')}}</span>
        </div> -->
        <!-- <div class="deletfotter" style="text-align:right;margin-top:28px;">
          <button type="button" class="btn btn-dark" style="margin-right:10px;" @click="submitDeleteDatalogger">{{$t('datalogger.confirm')}}</button>
          <button type="button" class="btn btn-light" @click="deletingDataloggerId = null">{{$t('datalogger.cancel')}}</button>
        </div> -->
      </div>
    </control-dialog>
    <!-- 删除结果提示(成功) -->
    <!-- v-if="delDataloggerSucVisible" -->
    <control-dialog :title="$t('project.delResults')" :visible.sync="delDataloggerSucVisible"
      :class="{ 'showDialog': delDataloggerSucVisible, 'hideDialog': !delDataloggerSucVisible }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <span class="showresulttext">{{ $t('project.delSuc') }}</span>
          <!-- <span class="showresulttext">{{dataloggerTipMsg}}</span> -->
          <!-- 确定 -->
          <div class="showoperate">
            <button type="button" class="btn btn-dark" @click="delDataloggerSucVisibleButton()">{{
              $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </control-dialog>
    <!-- 删除结果提示(失败) -->
    <!-- v-if="delDataloggerFailVisible" -->
    <control-dialog :title="$t('project.delResults')" :visible.sync="delDataloggerFailVisible"
      :class="{ 'showDialog': delDataloggerFailVisible, 'hideDialog': !delDataloggerFailVisible }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresulttext">{{ dataloggerTipMsg }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button type="button" class="btn btn-dark" @click="delDataloggerFailVisible = false;">{{
              $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </control-dialog>
    <!-- <div class="section-bottom"> -->
    <!-- <button :class="selectedplant.length ? 'button-solid' : 'button-disable'" @click="exportPlant(selectedplant)">批量导出</button> 
    <button class="button" :class="pagination.total ? 'button-solid' : 'button-disable'" @click="exportPlant('all')">导出所有</button>-->
    <!-- 数采器对应设备表弹窗 -->
    <!-- v-if="previewDataloggerInfo" -->
    <!-- <control-dialog
      :title="previewDataloggerInfo.alias"
      :visible.sync="previewDataloggerInfo"
      :class="{'showDialog': previewDataloggerInfo, 'hideDialog': !previewDataloggerInfo}"
      width="75vw"
      height="50vh"
    >
      <el-table
        slot="content"
        :data="previewDeviceList"
        stripe
        border
        height="100%"
        :empty-text="$t('errCode.258')"
        v-loading="loadingPreviewDevice"
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column :show-overflow-tooltip="true" :label="$t('device.device_name')">
          <template slot-scope="scope">
            <span
              class="redirect"
              @click="enterDevice(scope.row)"
              :title="scope.row.devalias||scope.row.sn"
            >{{scope.row.devalias||scope.row.sn}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="sn" :show-overflow-tooltip="true" :label="$t('device.device_sn')"></el-table-column>
        <el-table-column
          prop="status"
          :show-overflow-tooltip="true"
          :label="$t('device.device_status')"
        >
          <template slot-scope="scope">
            <span
              v-if="scope.row.status!==undefined"
              :class="`color-${$filter.deviceStatus[scope.row.status].name}`"
            >{{$filter.deviceStatus[scope.row.status].label}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="brand"
          :show-overflow-tooltip="true"
          :label="$t('device.device_type')"
        >
          <template slot-scope="scope">{{scope.row.brand | translateDeviceType}}</template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" :label="$t('device.device_model')">
          <template slot-scope="scope">
            <span :title="scope.row.devtype||'--'">{{scope.row.devtype||'--'}}</span>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" :label="$t('device.User_belong')">
          <template slot-scope="scope">
            <span :title="scope.row.usr||'--'">{{scope.row.usr||'--'}}</span>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" :label="$t('datalogger.administrator')">
          <template slot-scope="scope">
            <span :title="scope.row.dist||'--'">{{scope.row.dist||'--'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="devaddr"
          :show-overflow-tooltip="true"
          :label="$t('device.device_address')"
        ></el-table-column>
        <el-table-column
          prop="devcode"
          :show-overflow-tooltip="true"
          :label="$t('device.device_code')"
        ></el-table-column>
      </el-table>
    </control-dialog> -->
    <!-- 新增数采器 -->
    <!-- <datalogger-dialog
      :visible.sync="dialogDataloggerVisible"
      @submitSuc="handleAddSuc"
      v-if="dialogDataloggerVisible"
    ></datalogger-dialog> -->
    <!--修改数采器-->
    <!-- v-if="editingInfo" -->
    <!-- <datalogger-dialog
      v-if="editingInfo"
      :editing="editingInfo"
      :visible.sync="editingInfo"
      @submitSuc="handleEditSuc"
      @submitFail="handleEditFail"
    ></datalogger-dialog> -->
    <control-dialog :title="$t('datalogger.editDataloggerName')"
      :class="{ 'showDialog': editdataloggerInfo, 'hideDialog': !editdataloggerInfo }" :visible.sync="editdataloggerInfo"
      noFooter>
      <div slot="content">
        <el-form class="grid">
          <el-form-item :label="$t('datalogger.datalogger_name')" prop="alias" size="small">
            <el-input  maxlength="64" v-model="dialogAlias" clearable></el-input>
          </el-form-item>
        </el-form>
        <div style="text-align:right;">
          <button class="btn btn-dark" @click="submit()">{{ $t('device.confirm') }}</button>
        </div>
      </div>
      <div slot="footer">
      </div>
    </control-dialog>
    <!-- 修改结果提示(成功) -->
    <!-- v-if="editDataloggerSucVisible" -->
    <control-dialog :title="$t('datalogger.editResults')" :visible.sync="editDataloggerSucVisible"
      :class="{ 'showDialog': editDataloggerSucVisible, 'hideDialog': !editDataloggerSucVisible }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <span class="showresulttext">{{ $t('datalogger.modifySuc') }}</span>
          <!-- <span class="showresulttext">{{dataloggerTipMsg}}</span> -->
          <!-- 确定 -->
          <div class="showoperate">
            <button type="button" class="btn btn-dark" @click="editDataloggerSucVisible = false;">{{
              $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </control-dialog>
    <!-- 修改结果提示(失败) -->
    <!-- v-if="editDataloggerFailVisible" -->
    <control-dialog :title="$t('datalogger.editResults')" :visible.sync="editDataloggerFailVisible"
      :class="{ 'showDialog': editDataloggerFailVisible, 'hideDialog': !editDataloggerFailVisible }" width="500px"
      noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresulttext">{{ dataloggerTipMsg }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button type="button" class="btn btn-dark" @click="editDataloggerFailVisible = false;">{{
              $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </control-dialog>
    <!--重置数采器-->
    <control-dialog :title="$t('datalogger.resetDataloggerName')"
      :class="{ 'showDialog': resetDataloggerVisible, 'hideDialog': !resetDataloggerVisible }"
      :visible.sync="resetDataloggerVisible" noFooter>
      <div slot="content">
        <div style="font-size:16px;color:#DD6843;">{{ $t('datalogger.resetDataloggerExplain') }}</div>
        <div style="color:#D9E2E6;font-size:14px;margin:10px 0 20px;">
          <span>{{ $t('recharge.DataloggerPN') }}</span>
          <span>{{ this.resetDataloggerPn }}</span>
        </div>
        <el-input style="margin-bottom:30px;" v-model="resetDataloggerCode" :placeholder="$t('datalogger.please_title')"></el-input>
        <div style="text-align:right;">
          <button class="btn btn-light" style="margin-right:10px;color:#DD6843;border:1px solid #DD6843 "
            @click="resetDataloggerVisible = false;">{{ $t('device.cancel') }}</button>
          <button style="background:#DD6843;" class="btn btn-dark" @click="resetDataloggerConfirm()">{{
            $t('datalogger.reset') }}</button>
        </div>
      </div>
      <div slot="footer">
      </div>
    </control-dialog>
    <!-- 重置数采器结果提示(成功) -->
    <!-- v-if="dataloggerEditSucVisible" -->
    <control-dialog :title="$t('datalogger.resetResults')" :visible.sync="dataloggerResetSucVisible"
      :class="{ 'showDialog': dataloggerResetSucVisible, 'hideDialog': !dataloggerResetSucVisible }" width="500px"
      noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <span class="showresulttext">{{ $t('datalogger.resetSuc') }}</span>
          <!-- <span class="showresulttext">{{dataloggerTipMsg}}</span> -->
          <!-- 确定 -->
          <div class="showoperate">
            <button type="button" class="btn btn-dark" @click="dataloggerResetSucVisibleButton()">{{
              $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </control-dialog>
    <!-- 重置数采器结果提示(失败) -->
    <!-- v-if="dataloggerEditFailVisible" -->
    <control-dialog :title="$t('datalogger.resetResults')" :visible.sync="dataloggerResetFailVisible"
      :class="{ 'showDialog': dataloggerResetFailVisible, 'hideDialog': !dataloggerResetFailVisible }" width="500px"
      noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresulttext">{{ dataloggerTipMsg }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button type="button" class="btn btn-dark" @click="dataloggerResetFailVisible = false;">{{
              $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </control-dialog>
    <!--解绑数采器-->
    <control-dialog :title="$t('datalogger.unbindDataloggerName')"
      :class="{ 'showDialog': unbindDataloggerVisible, 'hideDialog': !unbindDataloggerVisible }"
      :visible.sync="unbindDataloggerVisible" noFooter>
      <div slot="content">
        <div style="font-size:16px;color:#DD6843;">{{ $t('datalogger.unbindDataloggerExplain') }}</div>
        <div style="color:#D9E2E6;font-size:14px;margin:10px 0 20px;">
          <span>{{ $t('recharge.DataloggerPN') }}</span>
          <span>{{ this.resetDataloggerPn }}</span>
        </div>
        <el-input style="margin-bottom:30px;" v-model="resetDataloggerCode"
          :placeholder="$t('datalogger.unbindTitle')"></el-input>
        <div style="text-align:right;">
          <button class="btn btn-light" style="margin-right:10px;color:#DD6843;border:1px solid #DD6843 "
            @click="unbindDataloggerVisible = false;">{{ $t('device.cancel') }}</button>
          <button style="background:#DD6843;" class="btn btn-dark" @click="unbindDataloggerConfirm()">{{
            $t('datalogger.unbind') }}</button>
        </div>
      </div>
      <div slot="footer">
      </div>
    </control-dialog>
    <!-- 解绑数采器结果提示(成功) -->
    <!-- v-if="dataloggerEditSucVisible" -->
    <control-dialog :title="$t('datalogger.unbindResults')" :visible.sync="dataloggerUnbindSucVisible"
      :class="{ 'showDialog': dataloggerUnbindSucVisible, 'hideDialog': !dataloggerUnbindSucVisible }" width="500px"
      noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <span class="showresulttext">{{ $t('datalogger.unbindSuc') }}</span>
          <!-- <span class="showresulttext">{{dataloggerTipMsg}}</span> -->
          <!-- 确定 -->
          <div class="showoperate">
            <button type="button" class="btn btn-dark" @click="dataloggerUnbindSucVisibleButton()">{{
              $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </control-dialog>
    <!-- 解绑数采器结果提示(失败) -->
    <!-- v-if="dataloggerEditFailVisible" -->
    <control-dialog :title="$t('datalogger.unbindResults')" :visible.sync="dataloggerUnbindFailVisible"
      :class="{ 'showDialog': dataloggerUnbindFailVisible, 'hideDialog': !dataloggerUnbindFailVisible }" width="500px"
      noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresulttext">{{ dataloggerTipMsg }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button type="button" class="btn btn-dark" @click="dataloggerUnbindFailVisible = false;">{{
              $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </control-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import dataloggerDialog from "@/components/dialognew/dataloggernew";
import controlDialog from "@/components/dialognew";
import updateDialog from "@/components/dialognew/flowIndex";
// import signal from "@/components/signalnew";
// 导出数采器报表
import exportPlantDialog from "@/components/dialognew/exportPlant";
import clipboard from "@/assets/js/clipboard";
export default {
  components: {
    controlDialog,
    // signal,
    exportPlantDialog,
    updateDialog
  },
  props: {
    dataloggerInfo2: {
      type: Object
    },
    activeTab: {
      type: String
    }
  },
  data () {
    return {
      rebooting: false,
      // 判断是否有权限，之前的经销商不存在权限
      disPermissionsLogo:sessionStorage.getItem("disPermissionsLogo")?JSON.parse(sessionStorage.getItem("disPermissionsLogo")):false,
      // 页面权限集合
      btnList: sessionStorage.getItem("buttonArr")?JSON.parse(sessionStorage.getItem("buttonArr")):[],
      // 重置数采器
      resetDataloggerPn: "",
      resetDataloggerCode: "",
      // 重启数采器
      rebootDataloggerData: {
        pn: "",
        status: "",
      },
      // 重启数采器弹框
      rebootDataloggerVisible: false,
      // 重置数采器弹框
      resetDataloggerVisible: false,
      // 重置数采器成功
      dataloggerResetSucVisible: false,
      // 重置数采器失败
      dataloggerResetFailVisible: false,
      // 解绑数采器弹框
      unbindDataloggerVisible: false,
      // 解绑数采器成功
      dataloggerUnbindSucVisible: false,
      // 解绑数采器失败
      dataloggerUnbindFailVisible: false,
      emptyText: false,
      paginationControl: false,
      progressUp: false,
      progress: 0,
      // 是否显示新增数采器弹窗
      dialogDataloggerVisible: false,
      selectedplant: [], //勾选数采器导出
      search: {
        status: "",
        pn: ""
      },
      status: {
        0: {
          num: 0,
          label: this.$t("datalogger.Normal"),
          name: "normal"
        },
        1: {
          num: 0,
          label: this.$t("datalogger.Offline"),
          name: "offline"
        }
      },
      file: null, //保存上传文件流的容器
      progerssComplete: false,
      uploadNowSize: "0.00", //现在正在上传的大小
      uploadTotalSize: "", //文件的总大小
      firmwareName: "",
      paramass: "", //中间变量
      searchrecharge: "",
      searchrechargeContents: "",
      dataparams: "",
      rechargelist: [],
      loadingDatalogger: false,
      loadingPreviewDevice: false, // 正在加载数采器对应设备表
      pagination: {
        currentPage: 1,
        total: 0,
        pagesize: 15
      }, // 分页数据
      dataloggerList: [],
      debugDataloggerVisible: false,
      debugingDataloggerId: null,
      upgradeDataloggerVisible: false,
      deletingDataloggerId: null,
      previewDataloggerInfo: null, // 查看的数采器
      previewDeviceList: [], // 查看的数采器对应设备表
      exportPlantParams: [], //导出报表
      datalogger: {
        devaddr: ""
      },
      devDebug: {
        cmd: ""
      },
      debugReturn: "",
      editingInfo: null, // 正在修改的数采器信息
      // 数采器基本信息
      dataloggerInfo: {
        alias: "",
        pn: ""
      },
      //数采器名称
      dialogAlias: '',
      // 显示上传固件二层弹窗
      dialogAdd: false,
      desc: "",
      // 升级成功提示
      upgradeDataloggerSucVisible: false,
      // 升级失败提示
      upgradeDataloggerFailVisible: false,
      // 删除成功提示
      delDataloggerSucVisible: false,
      // 删除失败提示
      delDataloggerFailVisible: false,
      //修改数采器弹窗
      editdataloggerInfo: false,
      // 修改成功提示
      editDataloggerSucVisible: false,
      // 修改失败提示
      editDataloggerFailVisible: false,
      // 操作返回提示
      dataloggerTipMsg: "",
      //复制内容
      dataloggerCopy: String,
    };
  },
  computed: {
    ...mapGetters({
      deviceInfo: 'getDeviceInfo',
      dataloggerDetail: 'getDataloggerDetail'
    }),
    deviceStatus () {
      // return this.$filter.deviceStatus[this.deviceInfo.status]
      return this.$filter.deviceStatusShadow[this.deviceInfo.status] || ""
    }
  },
  watch: {
    // 响应更新电站列表事件
    "$store.state.event.updateDataloggerList" (val) {
      if (val) {
        this.getDataloggerList();
        this.$store.state.event.updateDataloggerList = false;
      }
    },
    upgradeDataloggerVisible (val) {
      if (!val) {
        clearInterval(this.interval);
        this.interval = null;
        this.progressUp = false;
      }
    }
  },
  created () {
    this.getDataloggerList();
  },
  methods: {
    // 解绑数采器成功刷新数据
    dataloggerUnbindSucVisibleButton () {
      this.dataloggerUnbindSucVisible = false
      this.$store.state.event.updateDataloggerList = true;
      this.$store.commit('saveIsShow', 1);
    },
    // 解绑数采器弹窗
    unbindDatalogger (info) {
      this.unbindDataloggerVisible = true
      this.resetDataloggerPn = info
      this.resetDataloggerCode = ""
    },
    // 确定解绑数采器
    unbindDataloggerConfirm () {
      if (this.resetDataloggerCode === "YES") {
        this.unbindDataloggerVisible = false
        let param = {
          pn: this.resetDataloggerPn,
          level: 1,
        }
        this.$request.get("delDevicesResetPlant", param).then((res) => {
          if (res.err == 0) {
            this.dataloggerUnbindSucVisible = true
          } else {
            this.dataloggerUnbindFailVisible = true
            this.dataloggerTipMsg = this.$t(`errCode.${res.err}`);
          }
        })
      } else {
        this.$message.error(this.$t(`datalogger.resetCode`))
      }
    },
    // 重置数采器成功刷新数据
    dataloggerResetSucVisibleButton () {
      this.dataloggerResetSucVisible = false
      this.$store.state.event.updateDataloggerList = true;
      this.$store.commit('saveIsShow', 1);
    },
    // 重置数采器弹窗
    resetDatalogger (info) {
      this.resetDataloggerVisible = true
      this.resetDataloggerPn = info
      this.resetDataloggerCode = ""
    },
    // 确定重置数采器
    resetDataloggerConfirm () {
      if (this.resetDataloggerCode === "YES") {
        this.resetDataloggerVisible = false
        let param = {
          pn: this.resetDataloggerPn,
          level: 3,
        }
        this.$request.get("delDevicesResetPlant", param).then((res) => {
          if (res.err == 0) {
            this.dataloggerResetSucVisible = true
          } else {
            this.dataloggerResetFailVisible = true
            this.dataloggerTipMsg = this.$t(`errCode.${res.err}`);
          }
        })
      } else {
        this.$message.error(this.$t(`datalogger.resetCode`))
      }
    },
    // 确定重启数采器
    rebootDataloggerConfirm () {
      if (this.rebooting) return;
      this.rebooting = true;
      let param = {
        pn: this.rebootDataloggerData.pn
      }
      this.$request.get("restartCollector", param).then((res) => {
        this.rebooting = false;
        this.rebootDataloggerVisible = false
        if (res.err == 0) {
          if (this.rebootDataloggerData.status == 1) {
            this.$message.error(this.$t(`errCode.263`));
          } else {
            this.$message.success(this.$t("datalogger.rebootDataloggerSuc"));
          }
        } else {
          this.$message.error(this.$t(`errCode.${res.err}`));
        }
      }).catch(() => {
        this.rebooting = false;
      });
    },
    // 取消重启数采器
    rebootDataloggerCencel (info) {
      this.rebootDataloggerVisible = false
    },
    // 重启数采器弹窗
    rebootDatalogger (info) {
      if(this.disPermissionsLogo&&!this.btnList.includes('restart_collector')){
        return this.$message.warning(this.$t('account.No_permission_prompt'));
      }
      this.rebootDataloggerData.pn = info.pn
      this.rebootDataloggerData.status = info.status
      this.rebootDataloggerVisible = true
    },
    //复制功能
    copy () {
      this.dataloggerCopy = this.deviceInfo.pn
      //创建input标签
      var input = document.createElement('input')
      //将input的值设置为需要复制的内容
      input.value = this.dataloggerCopy;
      //添加input标签
      document.body.appendChild(input)
      //选中input标签
      input.select()
      //执行复制
      document.execCommand('copy')
      //成功提示信息
      this.$message.success(this.$t("datalogger.copy"))
      //移除input标签
      document.body.removeChild(input)
    },
    //进度条显示
    progressText (progress) {
      return progress === 100 ? this.$t("datalogger.finish") : `${progress}%`;
    },
    //勾选多项
    changeFun (val) {
      this.selectedplant = val; // 返回的是选中的列的数组集合
    },

    // 导出报表
    exportPlant (exportPlantParams) {
      if (!exportPlantParams.length) return false;
      this.exportPlantParams = exportPlantParams;
    },

    // 查询数采器列表
    getDataloggerList (reset) {
      this.paginationControl = false;
      if (reset) this.pagination.currentPage = 1;
      let param = {
        ...this.search,
        devtype: 2304,
        page: this.pagination.currentPage - 1,
        pagesize: this.pagination.pagesize
      };
      this.loadingDatalogger = true;
      this.$request.get("webQueryCollectorsEs", param).then(res => {
        if (res.err === 0) {
          this.dataloggerList = res.dat.collector;
          this.pagination.total = res.dat.total;
          if (this.pagination.total > this.pagination.pagesize) {
            this.paginationControl = true;
          }
        } else {
          // this.$message.warning(this.$t(`errCode.${res.err}`));
          this.emptyText = true;
          this.dataloggerList = [];
          this.pagination.total = 0;
        }
        this.loadingDatalogger = false;
      });
    },
    // 修改数采器提交
    submit () {
      let param = {
        pid: this.editingInfo.pid,
        pn: this.editingInfo.pn,
        alias: this.dialogAlias
      }
      this.$request.get("editCollectorEs", param).then((res) => {
        if (res.err == 0) {
          this.editdataloggerInfo = false
          this.handleEditSuc()
        } else {
          this.dataloggerTipMsg = this.$t(`errCode.${res.err}`);
          this.editDataloggerFailVisible = true;
          this.editdataloggerInfo = false
        }
      })
    },
    // 修改数采器
    // editDatalogger(pn) {
    //   this.$request.get("queryCollectorinfoEs", { pn }).then(res => {
    //     console.log('修改数采器:', res.dat);
    //     if (res.err === 0) {
    //       this.editingInfo = { pn, ...res.dat };
    //     } else {
    //       this.$message.error(this.$t(`errCode.${res.err}`));
    //     }
    //   });
    // },
    editDatalogger (info) {
      if(this.disPermissionsLogo&&!this.btnList.includes('edit_collector')){
        return this.$message.warning(this.$t('account.No_permission_prompt'));
      }
      this.editdataloggerInfo = true
      this.dialogAlias = info.alias
      let param = {
        pn: info.pn
      }
      this.$request.get("queryCollectorinfoEs", param).then(res => {
        if (res.err === 0) {
          this.editingInfo = {
            pn: info.pn,
            pid: info.pid,
            pname: info.pname,
            ...res.dat
          };
        } else {
          this.$message.error(this.$t(`errCode.${res.err}`));
        }
      });
    },
    // 修改数采器成功回调
    handleEditSuc () {
      // (设备所属数采器)
      // this.$message.success(this.$t("datalogger.modifySuc"));
      this.editDataloggerSucVisible = true;
      // this.getDataloggerList();
      // 更新本页数采器数据 (传递事件)
      this.$emit("refreshBelong");
      // 通知数采器列表更新
      this.$store.state.event.updateDataloggerList = true;
    },
    // 修改数采器失败回调
    handleEditFail (val) {
      this.dataloggerTipMsg = val;
      this.editDataloggerFailVisible = true;
    },
    // 调试数采器
    debugDatalogger (info) {
      if(this.disPermissionsLogo&&!this.btnList.includes('debug_collector')){
        return this.$message.warning(this.$t('account.No_permission_prompt'));
      }
      this.$store.commit("saveDeviceInfo", {
        pn: info.pn,
        sn: info.sn,
        deviceSn: info.deviceSn || info.sn,
        devcode: info.devcode,
        devaddr: info.devaddr,
        status: info.status,
        descx: info.descx,
        load: info.load,
        edate: info.edate,
        brand: info.brand,
        devalias: info.alias,
        collalias: info.calias,
        signal: info.signal,
        usr: info.usr,
        Firmware_Version: info.fireware,
        profitToday: info.profitToday,
        profitTotal: info.profitTotal,
        sellProfitToday: info.sellProfitToday,
        sellProfitTotal: info.sellProfitTotal,
        buyProfitToday: info.buyProfitToday,
        buyProfitTotal: info.buyProfitTotal,
      });
      this.$store.commit('saveIsShow', 4);
      this.$store.commit('saveDataloggerDetail', 2);
    },
    // 调试清空
    qingkong () {
      this.devDebug.cmd = null;
      this.debugReturn = null;
    },
    // 调试复制
    fuzhi (event) {
      clipboard(this.debugReturn, event);
    },
    // 发送指令
    submitDebugDatalogger () {
      if (this.datalogger.devaddr == null) {
        this.$message.error(this.$t("datalogger.devaddrfail"));
      } else if (this.datalogger.status == "1") {
        this.$message.error(this.$t("datalogger.Debugfail"));
      } else {
        this.debugReturn = this.$t("datalogger.instruction_response");
        let param = {
          pn: this.datalogger.pn,
          devaddr: this.datalogger.devaddr,
          cmd: this.devDebug.cmd
        };
        this.$request.get("sendCmdToDevice", param).then(res => {
          if (res.err == 0) {
            this.$message.success(this.$t("datalogger.debug_suc"));
            this.debugReturn = res.dat.dat;
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
            this.debugReturn = null;
          }
        });
      }
    },
    voltageArr (item) {
      this.rechargelist.forEach(element => {
        if (element.id == item) {
          this.searchrechargeContents = element
        }
      });
    },
    // 数采器固件升级
    upgradeDatalogger (info) {
      // this.queryFirmware();
      // this.upgradeDataloggerVisible = true;
      // this.dataparams = info;
      // this.progerssComplete = false;
      this.$store.commit('saveIsShow', 3);
    },
    // 查询固件列表
    queryFirmware () {
      this.searchrecharge = null;
      this.rechargelist = [];
      this.$request.getUPG("/upg/api/auth/web/shineDess/collector/upgrade/queryFiremware", { pagesize: 50 }).then(res => {
        if (res.code == 0) {
          res.data.items.forEach(item => {
            this.rechargelist.push({
              id: item.id,
              firmware: item.firmware,
              size: item.size
            });
          });
        }
      });
    },
    //点击选择文件的按钮(选择成功后直接关闭弹窗)
    uploadfile (event) {
      // 在下次 DOM 更新循环结束之后执行延迟回调。在修改数据之后立即使用这个方法，获取更新后的 DOM。
      this.$nextTick(() => {
        this.$refs.fileUploader.value = null;
      });
      let file = event.target.files[0];
      if (file.size > 8 * 1024 * 1024) {
        this.$message.error(this.$t("datalogger.fileExceed"));
        return;
      }
      let suffix = file.name.split(".").slice(-1)[0];
      if (suffix !== "bin" && suffix !== "hex" && suffix !== "s19") {
        this.$message.error(this.$t("datalogger.error1"));
        return;
      }
      this.$request.uploadfileAxios(file).then(res => {
        if (res.code === 0) {
          this.$message.success(this.$t("datalogger.uploadSuccess"));
        } else if (res.code === 6) {
          this.$message.error(this.$t("datalogger.error1"));
        } else {
          // this.$message.error(this.$t(`errCode.${res.code}`));
          this.$message.error(res.message);
        }
        this.queryFirmware();
      });
    },
    // 确认固件升级
    submitUpgradeDatalogger () {
      this.progress = 0;
      if (!this.searchrecharge) {
        this.$message.error(this.$t("datalogger.file_fist"));
      } else if (this.dataparams.status == "1") {
        this.$message.error(this.$t("datalogger.updatefail"));
      } else {
        this.firmwareName = this.searchrechargeContents.firmware;
        this.uploadTotalSize = this.$filter.formatNum(
          this.searchrechargeContents.size / (1024 * 1024),
          2
        );
        let params = {
          pn: this.dataparams.pn,
          firmwareId: this.searchrecharge
        };
        this.$request.postUPG("/upg/api/auth/web/shineDess/collector/firmwareUpgradeCollector", params).then(res => {
          if (res.code == 0) {
            if (res.data.ret == 0) {
              this.keyProgress = res.data.key;
              // this.$message.success(this.$t("datalogger.update_suc"));
              this.$message.success(this.$t("device.Upgrading"));
              // this.dataloggerTipMsg = this.$t("device.Upgrading");
              // this.upgradeDataloggerSucVisible = true;
              this.queryProgress();
              // this.upgradeDataloggerVisible = false;
              // this.dialogAdd = false;
            } else if (res.data.ret == 1) {
              this.$message.error(this.$t("device.System_Failed"));
              // this.dataloggerTipMsg = this.$t("device.System_Failed");
              // this.upgradeDataloggerFailVisible = true;
            } else if (res.data.ret == 2) {
              this.$message.error(this.$t("device.Device_Offline"));
              // this.dataloggerTipMsg = this.$t("device.Device_Offline");
              // this.upgradeDataloggerFailVisible = true;
            } else if (res.data.ret == 3) {
              this.$message.error(this.$t("device.In_Upgrading"));
              // this.dataloggerTipMsg = this.$t("device.In_Upgrading");
              // this.upgradeDataloggerFailVisible = true;
            }
          } else {
            // this.$message.error(this.$t(`errCode.${res.code}`));
            this.$message.error(res.message);
            // this.dataloggerTipMsg = this.$t(`errCode.${res.code}`);
            // this.upgradeDataloggerFailVisible = true;
          }
        });
      }
    },
    //取消升级
    upgradeCancel () {
      this.$request.putUPG("/upg/api/auth/web/shineDess/collector/collectorCancelFirmwareUpgrade", {
          pn: this.dataparams.pn,
          key: this.keyProgress
        })
        .then(res => {
          if (res.code == 0) {
            this.$message.success(this.$t("firmware.CancelUpgradeSuc"));
          } else if (res.code == 3 || res.code == 1) {
            this.upgradeDataloggerVisible = false;
          } else {
            this.$message.error(this.$t("firmware.FailedCancelUpgrade"));
          }
        });
    },
    // 查询升级进度
    queryProgress () {
      this.progressUp = true;
      this.progerssComplete = false;
      let params = {
        pn: this.dataparams.pn,
        // devaddr: this.dataparams.devaddr,
        // devcode: this.dataparams.devcode,
        // sn: this.dataparams.sn,
        key: this.keyProgress
      };
      this.interval = setInterval(() => {
        this.$request.getUPG("/upg/api/auth/web/shineDess/collector/queryCollectorFirmwareUpgradeProgress", params)
          .then(res => {
            if (res.code == 0) {
              if (res.data.status == 0) {
                let progress =
                  this.$filter.formatNum(res.data.progress / 10, 0) - 0;
                this.progress = progress;
                // this.progressText = progress + "%";
                this.uploadNowSize = this.$filter.formatNum(
                  (this.uploadTotalSize * progress) / 100,
                  2
                );
                if (this.progress >= 100) {
                  clearInterval(this.interval);
                  this.interval = null;
                  this.progressUp = false;
                  this.uploadNowSize = this.uploadTotalSize;
                  this.progerssComplete = true;
                  this.$message.success(this.$t("device.Update_Completed"));
                  setTimeout(() => {
                    this.upgradeDataloggerVisible = false;
                  }, 3000);
                  return;
                }
              } else if (res.data.status == 1) {
                this.$message.error(this.$t("firmware.upgrade_quit1"));
                clearInterval(this.interval);
                this.interval = null;
                this.upgradeDataloggerVisible = false;
                return;
              } else if (res.data.status == 2) {
                this.$message.error(this.$t("firmware.upgrade_quit2"));
                clearInterval(this.interval);
                this.interval = null;
                this.upgradeDataloggerVisible = false;
                return;
              } else if (res.data.status == 3) {
                this.$message.error(this.$t("firmware.upgrade_quit3"));
                clearInterval(this.interval);
                this.interval = null;
                this.upgradeDataloggerVisible = false;
                return;
              } else if (res.data.status == 4) {
                this.$message.error(this.$t("firmware.upgrade_quit4"));
                clearInterval(this.interval);
                this.interval = null;
                this.upgradeDataloggerVisible = false;
                return;
              } else if (res.data.status == 5) {
                this.$message.error(this.$t("firmware.upgrade_quit5"));
                clearInterval(this.interval);
                this.interval = null;
                this.upgradeDataloggerVisible = false;
                return;
              }
            } else {
              // this.$message.error(this.$t(`errCode.${res.code}`));
              this.$message.error(res.message);
              clearInterval(this.interval);
              this.interval = null;
            }
          });
      }, 2000);
    },
    // 删除数采器成功返回数采器列表
    delDataloggerSucVisibleButton () {
      this.delDataloggerSucVisible = false;
      this.$store.commit('saveIsShow', 1);
    },
    //删除数采器
    deleteDatalogger (pn) {
      if(this.disPermissionsLogo&&!this.btnList.includes('delete_collector')){
        return this.$message.warning(this.$t('account.No_permission_prompt'));
      }
      this.resetDataloggerCode = ""
      this.deletingDataloggerId = pn;
    },
    // 确定删除数采器
    submitDeleteDatalogger () {
      if (this.resetDataloggerCode === "YES") {
        this.$request
          .get("delCollectorFromPlant", { pn: this.deletingDataloggerId })
          .then(res => {
            if (res.err == 0) {
              // this.$message.success(this.$t("datalogger.deleteSuc"));
              this.dataloggerTipMsg = this.$t("datalogger.deleteSuc");
              this.delDataloggerSucVisible = true;
              this.deletingDataloggerId = null;
              // 通知数采器列表更新
              this.$store.state.event.updateDataloggerList = true;
              this.getDataloggerList();
            } else {
              // this.$message.error(this.$t(`errCode.${res.err}`));
              this.dataloggerTipMsg = this.$t(`errCode.${res.err}`);
              this.delDataloggerFailVisible = true;
            }
          });
      } else {
        this.$message.error(this.$t(`datalogger.resetCode`))
      }
    },
    // 新增数采器成功回调
    handleAddSuc () {
      this.$message.success(this.$t("datalogger.add_suc"));
      this.getDataloggerList();
    }
  }
};
</script>
<style lang="less" scoped>
@import url('../../../../assets/css/mixin.less');

.devicebelongoperate {
  width: 100%;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  padding: 15px 30px;
  display: flex;
  // margin-bottom: 10px;
  justify-content: space-between;
  // flex-start
  align-items: center;
  background: rgb(34, 45, 53);
  color: #ffffff;

  .btn {
    // width: 50px;
    // height: 30px;
    // line-height: 30px;
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 14px;
    // margin-right: 10px;
    cursor: pointer;
  }

  .btn-dark {
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    border: none;
  }

  .btn-light {
    background: transparent;
    color: @primaryTextColor;
    border: 1px solid @primaryTextColor;
  }

  .top-info {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;

    .info-one {
      display: flex;
      align-items: center;
      justify-content: flex-start;

      .label {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        height: 32px;
        .sc(14px, #333);

        // 设备状态带阴影
        .status-icon-shadow {
          width: 14px;
          height: 14px;
          border-radius: 7px;
          margin: 0 14px 0 0;
        }

        .status-normal-shadow {
          background-color: rgba(48, 236, 112, 1);
          box-shadow: 1px 1px 3px rgba(48, 236, 112, 1);
        }

        .status-offline-shadow {
          background-color: rgba(183, 183, 183, 1);
          box-shadow: 1px 1px 3px rgba(183, 183, 183, 1);
        }

        .status-standby-shadow {
          background-color: rgba(73, 222, 255, 1);
          box-shadow: 1px 1px 3px rgba(73, 222, 255, 1);
        }

        .status-fault-shadow {
          background-color: rgba(236, 150, 48, 1);
          box-shadow: 1px 1px 3px rgba(236, 150, 48, 1);
        }

        .status-warning-shadow {
          background-color: rgba(255, 62, 62, 1);
          box-shadow: 1px 1px 3px rgba(255, 62, 62, 1);
        }
      }

      .namebox {
        // display: block;
        // text-align: left;
        width: 90%;

        .name {
          display: inline-block;
          width: 100%;
          font-family: Microsoft YaHei;
          font-size: 20px;
          font-weight: bold;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
      }

      .ico-edit {
        display: inline-block;
        width: 16px;
        height: 16px;
        background: url(../../../../assets/img/general/Icon_Pencil.png);
        background-repeat: no-repeat;
        background-size: 100%;
        background-position: center;
      }
    }
  }

  .top-operate {
    .operation {
      // width: 86px;
      // height: 32px;
      border-radius: 6px;
      border: 1px solid rgba(85, 180, 145, 1);
      box-sizing: border-box;
      background-color: @primaryButtonColor;
      padding: 6px 12px;
      color: #ffffff;

      i {
        font-size: 18px;
        vertical-align: middle;
      }

      .icon-text1 {
        display: inline-block;
        margin-left: 6px;
      }

      // 是否关注
      .followno {
        background-image: url(../../../../assets/img/general/Icon_Operate_Follow_Light.png);
      }

      .followyes {
        background-image: url(../../../../assets/img/general/Icon_Operate_Follow_Dark.png);
      }

      .ico-export {
        background-image: url(../../../../assets/img/general/Icon_Operate_Export.png);
      }

      .ico-debug {
        background-image: url(../../../../assets/img/general/Icon_Operate_Debug.png);
      }

      .ico-control {
        background-image: url(../../../../assets/img/general/Icon_Operate_Control.png);
      }

      .ico-upgrade {
        background-image: url(../../../../assets/img/general/Icon_Operate_Upgrade.png);
      }

      .ico-delete {
        background-image: url(../../../../assets/img/general/Icon_Operate_Delete.png);
      }

      .icobase {
        width: 24px;
        height: 24px;
        display: inline-block;
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
        vertical-align: middle;
      }
    }

    .delBgc {
      border: 1px solid rgba(255, 104, 67, 1);
      background: rgba(255, 104, 67, 0.5);
      color: #ffffff;
    }
  }

  .gTool {
    display: flex;
    justify-content: flex-end;
    align-items: center;

    .gRowA {
      margin-right: 10px;
    }
  }

  // 数采器调试
  .debug-return {
    border: 1px solid rgba(255, 255, 255, 0.5);
    border-radius: 4px;
    padding: 6px 8px;
    background: rgba(43, 56, 66, 1);

    /deep/.el-textarea__inner {
      border: none;
      background: rgba(43, 56, 66, 1);
    }

    .return-tool {
      border-top: 1px dashed rgba(204, 206, 221, 0.5);
      text-align: right;
      padding: 6px 10px 0px;
      margin-top: 5px;

      .btn:hover {
        color: @primaryTextColor;

        .ico-clear {
          background: url(../../../../assets/img/general/Icon_Debug_Delete_Dark.png);
        }

        .ico-copy {
          background: url(../../../../assets/img/general/Icon_Debug_Copy_Dark.png);
        }
      }

      .btn {
        padding: 0px;
        color: rgba(235, 235, 235, 1);
        font-size: 12px;
        cursor: pointer;
      }

      .ico-clear {
        background: url(../../../../assets/img/general/Icon_Debug_Delete.png);
      }

      .ico-copy {
        background: url(../../../../assets/img/general/Icon_Debug_Copy.png);
      }

      .ico {
        display: inline-block;
        width: 16px;
        height: 16px;
        background-repeat: no-repeat;
        background-size: 100%;
        background-position: center;
        vertical-align: middle;
      }
    }
  }

  // 上传固件二次弹窗
  .upload-contents {
    border-radius: 6px;
    border: 1px dashed rgba(255, 255, 255, 0.5);
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .upload-buttonEquipment {
      background: transparent;
      border: none;
      cursor: pointer;
      padding: 6px 16px 6px 10px;
      color: rgba(255, 255, 255, 0.5);
      font-size: 14px;

      i {
        color: rgb(56, 165, 118);
        font-size: 32px;
      }
    }

    .upload-input {
      display: none;
    }
  }

  // 固件升级状态窗
  .upgradeNew {

    .processstatue,
    .processstatueEquipment {
      font-size: 16px;
      color: #16D09A;
    }

    /deep/.el-progress__text {
      color: #ffffff;
    }

    .progerssComplete,
    .progerssCompleteEquipment {
      background: transparent;
    }
  }
}

// #操作结果提示#
.showresultbox {
  display: flex;
  flex-direction: column;
  align-items: center;

  // 图标
  .showsuccess {
    border: 3px solid rgba(37, 255, 174, 1);
    background-color: rgba(19, 195, 156, 1);
    background-image: url(../../../../assets/img/general/Icon_Finished.png);
    background-size: 70px 70px;
  }

  .showfail {
    border: 3px solid rgba(246, 189, 189, 1);
    background: rgba(251, 75, 75, 1);
    background-image: url(../../../../assets/img/general/Icon_Failed.png);
    background-size: 120px 120px;
  }

  .showbase {
    width: 100px;
    height: 100px;
    box-sizing: border-box;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 50%;
  }

  // 提示
  .showresulttext {
    font-weight: bold;
    font-size: 18px;
    margin-top: 20px;
    margin-bottom: 30px;
    color: rgba(255, 255, 255, 1);
  }

  // 操作
  .showoperate {
    text-align: center;
  }

  .showresultbtn {
    width: 102px;
    height: 30px;
    margin-top: 10px;
    border-radius: 6px;
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    font-size: 14px;
  }
}
</style>
